<template>
  <div class="loader-wrapper" v-if="loading">
    <div class="loader-index"><span></span></div>
    <svg>
      <defs></defs>
      <filter id="goo">
        <fegaussianblur in="SourceGraphic" stddeviation="11" result="blur"></fegaussianblur>
        <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"> </fecolormatrix>
      </filter>
    </svg>
  </div>
  <template v-else><div v-if="releaseStale" class="release-notice" role="alert"><strong>A newer ClockSpotter release is available.</strong><span> Refresh before saving changes.</span><button class="btn btn-light btn-sm" @click="refreshRelease">Refresh now</button></div><router-view></router-view></template>
</template>

<script>



export default {
  name: 'App',
  data() {
    return {
      loading: true,
      releaseStale: window.__clockspotterStaleBuild === true,
    }
  },
  watch: {
    '$route'() {
      // setTimeout(() => {
      //   this.loading = !this.loading
      // }, 1000)
      // this.loading = !this.loading
    }
  },
  mounted() {
    this.loading = false;
    this.releaseListener = () => { this.releaseStale = true; };
    window.addEventListener('clockspotter:stale-release', this.releaseListener);
  },
  beforeUnmount() { window.removeEventListener('clockspotter:stale-release', this.releaseListener); },
  methods: { refreshRelease() { window.location.reload(); } },
}
</script>
<style scoped>.release-notice{position:fixed;z-index:2000;left:0;right:0;top:0;display:flex;align-items:center;justify-content:center;gap:.75rem;padding:.65rem 1rem;background:#b42318;color:#fff;box-shadow:0 .2rem .7rem rgba(0,0,0,.2)}@media(max-width:575.98px){.release-notice{align-items:flex-start;flex-wrap:wrap;justify-content:flex-start}}</style>

